const menuViewMap = {
};
  
export default menuViewMap;